import { defineComponent as _defineComponent } from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'WhatsAppMetaConfirmDialog',
  props: {
    open: { type: Boolean, required: true },
    title: { type: String, required: true },
    description: { type: String, required: true },
    confirmLabel: { type: String, required: true },
    isSubmitting: { type: Boolean, required: true }
  },
  emits: ["close", "confirm"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const { t } = useI18n();
const emit = __emit;

const close = () => {
    if (!props.isSubmitting) emit('close');
};

const confirm = () => {
    if (!props.isSubmitting) emit('confirm');
};

const __returned__ = { props, t, emit, close, confirm, get Dialog() { return Dialog }, get DialogPanel() { return DialogPanel }, get DialogTitle() { return DialogTitle }, get TransitionChild() { return TransitionChild }, get TransitionRoot() { return TransitionRoot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})